import { render } from "./OTCProjectCardSmall.vue?vue&type=template&id=2a67eff4&scoped=true"
import script from "./OTCProjectCardSmall.vue?vue&type=script&lang=js"
export * from "./OTCProjectCardSmall.vue?vue&type=script&lang=js"

import "./OTCProjectCardSmall.vue?vue&type=style&index=0&id=2a67eff4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a67eff4"]])

export default __exports__